import { Button, Input, Modal } from "antd";
import { useEffect, useRef } from "react";

const QrCodeDialog = ({ qrCodeOpen, handleQrcodeCancel, base64QR }) => {
  return (
    <Modal
      title=//         fontSize: "16px", //         justifyContent: "center", //         alignItems: "center", //         display: "flex", //       style={{ //     <strong //   {
      //         fontWeight: "bold",
      //         background: "#0cf3e0",
      //         borderRadius: "8px",
      //         padding: "4px 8px",
      //       }}
      //     >
      "QR CODE"
      // </strong>
      //   }
      open={qrCodeOpen}
      onCancel={handleQrcodeCancel}
      closable={true}
      //   okText="OK"
      //     cancelText="Cancel"
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
    >
      <div>
        <div style={{ textAlign: "center" }}>
          <img
            style={{ maxWidth: "200px", maxHeight: "200px" }}
            src={base64QR}
            alt="logo"
          />
        </div>
      </div>
      <div
        style={{
          textAlign: "center",
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <Button
          type="primary"
          onClick={handleQrcodeCancel}
          style={{
            width: 100,
            backgroundColor: "#51BB8F",
            borderRadius: "8px",
          }}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default QrCodeDialog;
